import React from "react";
import { DataTable } from "../../../DataTable/DataTable";
import { ReturnHistory } from "./types";

const ReturnHistoryTable = () => {
      const [isLoading, setIsLoading] = React.useState(false);
      const [currentPage, setCurrentPage] = React.useState(1);
      const [pageSize, setPageSize] = React.useState(10);
      const [totalPages, setTotalPages] = React.useState(1);
      const [totalItemsCount, setTotalItemsCount] = React.useState(0);
      const [returnHistory, setReturnHistory] = React.useState<ReturnHistory[]>([
        {
    id: "1",
    itemName: {
      id: "",
      name: "Paracetamol 500mg",
      category: "Pain Relief",
      image: "https://via.placeholder.com/40x40.png?text=P",
    },
    reason: "Damaged packaging",
    orderId: "ORD123456",
    dlNumber: "DL-451212",
    itemWorth: "₹50",
    returnDate: "2024-09-20",
  },
  {
    id: "2",
    itemName: {
      id: "",
      name: "Amoxicillin 250mg",
      category: "Antibiotic",
      image: "https://via.placeholder.com/40x40.png?text=A",
    },
    reason: "Expired medicine",
    orderId: "ORD123789",
    dlNumber: "DL-321654",
    itemWorth: "₹120",
    returnDate: "2024-09-18",
  },
])
    const columns = [
  {
    key: "ItemName",
    title: "Item Name",
    width: "w-[200px]",
    render: (item: ReturnHistory) => (
      <div className="flex items-center space-x-2">
        <img
          src={item?.itemName.image || ""}
          alt={item?.itemName.name}
          className="w-8 h-8 rounded"
        />
        <div
          className="text-sm font-medium line-clamp-2 cursor-default"
          title={item?.itemName.name}
        >
          {item.itemName.name || "N/A"}
        </div>
      </div>
    ),
  },
  {
    key: "Reason",
    title: "Reason",
    width: "w-[200px]",
    render: (item: ReturnHistory) => (
      <div
        className="text-sm font-medium line-clamp-2 cursor-default"
        title={item.reason}
      >
        {item.reason || "N/A"}
      </div>
    ),
  },
  {
    key: "OrderID",
    title: "Order ID",
    width: "w-[200px]",
    render: (item: ReturnHistory) => (
      <div className="text-sm font-medium">{item.orderId || "N/A"}</div>
    ),
  },
  {
    key: "DLNumber",
    title: "DL Number",
    width: "w-[200px]",
    render: (item: ReturnHistory) => (
      <div className="text-sm font-medium">{item.dlNumber || "N/A"}</div>
    ),
  },
  {
    key: "ItemWorth",
    title: "Item Worth",
    width: "w-[200px]",
    render: (item: ReturnHistory) => (
      <div className="text-sm font-medium">{item.itemWorth || "N/A"}</div>
    ),
  },
  {
    key: "ReturnDate",
    title: "Return Date",
    width: "w-[200px]",
    render: (item: ReturnHistory) => (
      <div className="text-sm font-medium">{item.returnDate || "N/A"}</div>
    ),
  }
];
    return (
        <div>
            <DataTable
               data={returnHistory}
               columns={columns}
               isLoading={isLoading}
               customFilters={[]}
               pagination={{
                 currentPage,
                 setCurrentPage,
                 setTotalPages,
                 totalPages,
                 totalItemsCount,
                 pageSize,
                 setPageSize,
               }}
          />
        </div>
    );
};

export default ReturnHistoryTable;